import React from "react";

const Public: React.FC = () => {
    return (
        <div>
            <h1>Hello World</h1>
            <p>Welcome to the Public page!</p>
        </div>
    );
};

export default Public;
